/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import {AuthenticationService} from '../app/services/authentication.service';
import { Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
@Component({
  selector: 'ngx-app',
  template: '<router-outlet ></router-outlet>',
})
export class AppComponent implements OnInit {
  private destroy$: Subject<void> = new Subject<void>();
  user:string;
  clientusername:string;
  role:string;
  appname:string;
  Objid:string;
  constructor(private analytics: AnalyticsService, private seoService: SeoService,private _AuthenticationService:AuthenticationService) {
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    let user=localStorage.getItem('currentUser')
    if(user){
      this._AuthenticationService.getUserData()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => {
        this.user = users.data;
        this.clientusername = users.data.username;
        this.role = users.data.role;
        this.appname = users.data.application;
        this.Objid = users.message;
    });
    // this.clearStorage();
    }
  }
  clearStorage() {

    let session = sessionStorage.getItem('ref');

    if (session == null) {
      let logouttime=localStorage.getItem('logouttime')
        this._AuthenticationService.logouttotal(this.role, this.Objid, logouttime, this.clientusername);
        localStorage.removeItem('currentUser');
    }else{
      let logouttime = new Date();
      localStorage.setItem('logouttime',logouttime.toString())
    }
}
}
